export function numberWithSpaces(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

export function normalizeNum(num, digits = 2) {
  return (
    Math.round(parseFloat(num).toFixed(digits) * Math.pow(10, digits)) /
    Math.pow(10, digits)
  );
}

export function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

export function getCf(ms) {
  return Math.floor(100 * Math.pow(Math.E, 0.00006 * ms)) / 100;
}

export function getCf2(ms) {
  return Math.pow(Math.E, 0.00006 * ms);
}

export function plural(number, titles) {
  const cases = [2, 0, 1, 1, 1, 2];
  return titles[
    number % 100 > 4 && number % 100 < 20
      ? 2
      : cases[number % 10 < 5 ? number % 10 : 5]
  ];
}

export function gameLogo(game) {
  let file = 'default.png';
  if (game === 'Dota 2') file = 'dota.png';
  if (game === 'CSGO') file = 'csgo.png';
  if (game === 'WOT') file = 'wot.png';
  if (game === 'starcraft') file = 'starcraft.png';
  if (game === 'League of Legends') file = 'lol.png';
  return `${app.assetsPath}/images/esports/games/${file}`;
}

export const BET_STATUS_PENDING = 0;
export const BET_STATUS_ACCEPTED = 1;
export const BET_STATUS_ERROR = 2;
export const BET_STATUS_NOT_ACCEPTED = 3;
export const BET_STATUS_WIN = 4;
export const BET_STATUS_LOOSE = 5;
export const BET_STATUS_REFUND = 6;

export function betStatus(statusText) {
  if (statusText === 'Принята') return 'pending';
  // if (statusText === BET_STATUS_ACCEPTED) return "accepted";
  // if (statusText === BET_STATUS_ERROR) return "error";
  // if (statusText === "Отменена") return "not_accepted";
  if (statusText === 'Сыграла') return 'win';
  if (statusText === 'Проиграла') return 'loose';
  if (statusText === 'Отменена') return 'refund';
  return '';
}

export const UPDATE_PERIOD = 5000;

export function chunk(arr, chunkSize) {
  const result = [];
  for (let i = 0, len = arr.length; i < len; i += chunkSize)
    result.push(arr.slice(i, i + chunkSize));
  return result;
}

export const capitalize = (s) => {
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export const isIOS = () =>
  [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod',
  ].includes(navigator.platform) ||
  // iPad on iOS 13 detection
  (navigator.userAgent.includes('Mac') && 'ontouchend' in document);



// WEBPACK FOOTER //
// ./app/utils/index.js